"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');


var _peers = require('shared/selectors/peers');
var _hooks = require('web/services/hooks');

// Resolves a user key (a row's CreatedBy) to a display name from the users
// already in the store; null when the user isn't loaded.
const useUserNameOf = () => {
  const usersV1 = _hooks.useAppSelector.call(void 0, _peers.selectAllV1Users)
  const usersV2 = _hooks.useAppSelector.call(void 0, _peers.selectAllV2Users)
  return _react.useCallback.call(void 0, 
    (userKey) => {
      if (!userKey) return null
      const v2 = _optionalChain([usersV2, 'optionalAccess', _ => _[userKey]])
      if (_optionalChain([v2, 'optionalAccess', _2 => _2.Name])) return v2.Name
      const user = v2 || _optionalChain([usersV1, 'optionalAccess', _3 => _3[userKey]])
      return (user && `${user.FirstName || ''} ${user.LastName || ''}`.trim()) || null
    },
    [usersV1, usersV2],
  )
}

exports. default = useUserNameOf
